var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import SelectDepartment from "~/components/business-component/select-department.vue";
import NumberRange from "~/components/common/number-range.vue";
import { Getter, State } from "vuex-class";
import { VisitCaseManageService } from "~/services/domain-service/visit-case-manage.service";
import { ApplyType, CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import TurnSourceApply from "~/components/apply-component/turn-source-apply.vue";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import PrincipalRecovery from "~/components/apply-component/principal-recovery.vue";
var VisitRecoverCaseManage = /** @class */ (function (_super) {
    __extends(VisitRecoverCaseManage, _super);
    function VisitRecoverCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            loanDate: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            deptId: '',
            deptIds: [],
            currentCollectorRealName: '',
            recordFollowInTime: [],
            partnerName: '',
            batchNumber: ''
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        _this.dialog = {
            apply: false,
            principalRecovery: false
        };
        _this.caseChannel = CASE_CHANNEL.visit;
        _this.applyType = {};
        return _this;
    }
    /**
     * 查询案件
     */
    VisitRecoverCaseManage.prototype.refreshData = function () {
        var _this = this;
        this.visitCaseManageService
            .visitRecoverCasePool(this.paramsHandler(), this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    VisitRecoverCaseManage.prototype.created = function () {
        this.refreshData();
    };
    VisitRecoverCaseManage.prototype.departemntChange = function (id, code) { };
    VisitRecoverCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.deptId = this.model.deptIds.length ? this.model.deptIds[this.model.deptIds.length - 1] : '';
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        params.recordFollowInTimeMin = this.model.recordFollowInTime.length ? this.$filter.dateTimeFormat(this.model.recordFollowInTime[0]) : '';
        params.recordFollowInTimeMax = this.model.recordFollowInTime.length ? this.$filter.dateTimeFormat(this.model.recordFollowInTime[1]) : '';
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        delete params.recordFollowInTime;
        delete params.deptIds;
        return params;
    };
    /**
     * 重置dataRange
     */
    VisitRecoverCaseManage.prototype.follFeedback = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: "", max: "" };
        this.model.personalCollectionRemainingDays = { min: "", max: "" };
    };
    /**
     * 申请流转
     */
    VisitRecoverCaseManage.prototype.applyFlowClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.applyType = ApplyType.turn;
                this.verifySelection();
                return [2 /*return*/];
            });
        });
    };
    VisitRecoverCaseManage.prototype.verifySelection = function () {
        if (this.selectionList.length === 0) {
            this.$message("\u8BF7\u9009\u62E9\u8981" + this.applyType.name + "\u7684\u6848\u4EF6");
            return;
        }
        this.dialog.apply = true;
    };
    /**
     * 移动到待催收中
     */
    VisitRecoverCaseManage.prototype.moveToPoolClick = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$message("\u8BF7\u9009\u62E9\u8981\u64CD\u4F5C\u7684\u6848\u4EF6");
            return;
        }
        var ids = { ids: this.selectedCaseIds };
        this.visitCaseManageService.moveToWaitDistribution(ids).subscribe(function (data) {
            _this.$message.success("操作成功");
            _this.refreshData();
        });
    };
    Object.defineProperty(VisitRecoverCaseManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 进入查看执行页
     */
    VisitRecoverCaseManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Visit_recover,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 委托方回收
     */
    VisitRecoverCaseManage.prototype.dealManualPartReturnCase = function () {
        if (this.selectionList.length !== 0) {
            this.dialog.principalRecovery = true;
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u8FDB\u884C\u59D4\u6258\u65B9\u56DE\u6536\u7684\u6848\u4EF6");
        }
    };
    __decorate([
        Dependencies(PageService)
    ], VisitRecoverCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], VisitRecoverCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(VisitCaseManageService)
    ], VisitRecoverCaseManage.prototype, "visitCaseManageService", void 0);
    __decorate([
        Getter
    ], VisitRecoverCaseManage.prototype, "visitDepartmentData", void 0);
    __decorate([
        State
    ], VisitRecoverCaseManage.prototype, "principalList", void 0);
    VisitRecoverCaseManage = __decorate([
        Auth(608),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                TurnSourceApply: TurnSourceApply,
                SelectDepartment: SelectDepartment,
                PrincipalRecovery: PrincipalRecovery
            }
        })
    ], VisitRecoverCaseManage);
    return VisitRecoverCaseManage;
}(Vue));
export default VisitRecoverCaseManage;
